import { render, staticRenderFns } from "./Grundgedanke.vue?vue&type=template&id=05c6f6e2&scoped=true"
import script from "./Grundgedanke.vue?vue&type=script&lang=js"
export * from "./Grundgedanke.vue?vue&type=script&lang=js"
import style0 from "./Grundgedanke.vue?vue&type=style&index=0&id=05c6f6e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c6f6e2",
  null
  
)

export default component.exports